module.exports = __webpack_public_path__ + "static/media/png-logo.6ce3b526.svg";